// @flow

import React from "react";
import { Redirect } from "react-router";
import type { Dispatch as ReduxDispatch } from "redux";

type LogoutProps = {
  clearUserData: (dispatch: ReduxDispatch<any>, getState: any) => any,
  loginPath: string
};

const Logout = ({ clearUserData, loginPath }: LogoutProps) => {
  clearUserData();
  return <Redirect to={loginPath} />;
};

export default Logout;
